import {
    ClickMapQuestion,
    DragAndDropQuestion,
    LongMultipleChoiceQuestion,
    MultipleChoiceQuestion,
} from '../../models';
import { QuestionType } from '../enums';

export const questionData = [
    //1 need info
    {
        type: QuestionType.DragAndDrop,
        image: require('../../assets/images/match-truck_A2.png'),
        video: '',
        points: 1,
        text: 'Drag the parts into place to help build iNSTRUCKTA!',
        questionAudio: '',
        descriptionAudio: '',
        descriptionConditions: 'onlyImg',
        description: '',
        descriptionImage: require('../../assets/questionsAssets/images/match-truck_B.png'),
        answers: [
            {
                title: '',
                detail: require('../../assets/images/match-truck_A1.png'),
                width: 0.107,
                height: 0.27,
                current: {
                    left: '',
                    top: '',
                },
                target: 0,
                from: {
                    x: 0,
                    y: 0,
                },
                to: {
                    x: 0.751,
                    y: 0.73,
                },
                isDropped: false,
                background: 'transparent',
            },
            {
                title: '',
                detail: require('../../assets/images/match-truck_A3.png'),
                width: 0.8,
                height: 1,
                current: {
                    left: '',
                    top: '',
                },
                target: 0,
                from: {
                    x: 0,
                    y: 0,
                },
                to: {
                    x: 0,
                    y: 0,
                },
                isCorrect: false,
                background: 'transparent',
            },
            {
                title: '',
                detail: require('../../assets/images/match-truck_A7.png'),
                width: 0.059,
                height: 0.37,
                current: {
                    left: '',
                    top: '',
                },
                target: 0,
                from: {
                    x: 0,
                    y: 0,
                },
                to: {
                    x: 0.913,
                    y: 0.29,
                },
                isCorrect: false,
                background: 'transparent',
            },
            {
                title: '',
                detail: require('../../assets/images/match-truck_A4.png'),
                width: 0.065,
                height: 0.27,
                current: {
                    left: '',
                    top: '',
                },
                target: 0,
                from: {
                    x: 0,
                    y: 0,
                },
                to: {
                    x: 0.875,
                    y: 0.73,
                },
                isCorrect: false,
                background: 'transparent',
            },
            {
                title: '',
                detail: require('../../assets/images/match-truck_A5.png'),
                width: 0.155,
                height: 0.27,
                current: {
                    left: '',
                    top: '',
                },
                target: 0,
                from: {
                    x: 0,
                    y: 0,
                },
                to: {
                    x: 0.59,
                    y: 0.735,
                },
                isCorrect: false,
                background: 'transparent',
            },
        ],
    } as DragAndDropQuestion,
    //2 true/false
    {
        type: QuestionType.MultipleChoice,
        image: require('../../assets/questionsAssets/images/16-2_do-not-overtake.png'),
        video: '',
        points: 1,
        text: "A vehicle fitted with a 'DO NOT OVERTAKE TURNING VEHICLE' sign on the rear can legally use more than one lane when turning right or left?",
        questionAudio: '',
        descriptionAudio: '',
        descriptionConditions: '',
        description:
            'Vehicles 7.5 metres long or longer need to make wide turns. Do not overtake once the driver has signalled an intention to turn.<br> They may cut the corner, when they are turning at an intersection. They are also legally allowed to cross over a continuous line leading up to the intersection. ',
        descriptionImage: '',
        answers: [
            { text: 'True', isCorrect: true, answer: false, background: '' },
            { text: 'False', isCorrect: false, answer: false, background: '' },
        ],
    } as MultipleChoiceQuestion,
    //3 true/false
    {
        type: QuestionType.MultipleChoice,
        image: require('../../assets/questionsAssets/images/trucks_turning-question.jpg'),
        video: '',
        points: 1,
        text: 'When a vehicle fitted with the "do not overtake turning vehicle" sign is indicating to turn you should hold back and give the truck driver the space they need to make the turn.',
        questionAudio: '',
        descriptionAudio: '',
        descriptionConditions: 'imgRight',
        description:
            'Also, When a truck is turning onto the road you are on, keep back from the intersection as it may require more space to make the turn safely.',
        descriptionImage: require('../../assets/questionsAssets/images/trucks_turning-answer.jpg'),
        answers: [
            { text: 'True', isCorrect: true, answer: false, background: '' },
            { text: 'False', isCorrect: false, answer: false, background: '' },
        ],
    } as MultipleChoiceQuestion,
    //4 need new answer
    {
        type: QuestionType.ClickMap,
        image: require('../../assets/questionsAssets/images/blind-spot-question.jpg'),
        points: 1,
        text: 'Click on the vehicles that are in the trucks blind spots.',
        questionAudio: '',
        descriptionAudio: '',
        descriptionConditions: 'imgRightLongAnswer',
        description:
            '• Trucks have four main blind spots. <br>  • Immediately in front of the truck.<br>  • Directly behind the truck.<br>  • On the driver side next to the driver’s door. <br>  • On the passenger side, next to the passenger’s door and extending sideways <br>• The size and location of blind spots vary for different kinds of trucks. The most important thing to remember is you need to keep out of blind spots to help you keep safe.',
        descriptionImage: require('../../assets/questionsAssets/images/blind-spot-answer.jpg'),
        answers: [
            {
                position: {
                    x: 0.07,
                    y: 0.43,
                },
                width: 0.3,
                height: 0.12,
                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
            {
                position: {
                    x: 0.81,
                    y: 0.43,
                },
                width: 0.1,
                height: 0.12,
                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
            {
                position: {
                    x: 0.525,
                    y: 0.27,
                },
                width: 0.12,
                height: 0.12,
                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
            {
                position: {
                    x: 0.615,
                    y: 0.59,
                },
                width: 0.12,
                height: 0.12,
                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
            {
                position: {
                    x: 0.785,
                    y: 0.57,
                },
                width: 0.12,
                height: 0.12,
                color: 'transparent',
                selected: false,
                isCorrect: false,
            },
            {
                position: {
                    x: 0.385,
                    y: 0.585,
                },
                width: 0.12,
                height: 0.12,
                color: 'transparent',
                selected: false,
                isCorrect: false,
            },
            {
                position: {
                    x: 0.205,
                    y: 0.58,
                },
                width: 0.12,
                height: 0.12,
                color: 'transparent',
                selected: false,
                isCorrect: false,
            },
            {
                position: {
                    x: 0.07,
                    y: 0.287,
                },
                width: 0.12,
                height: 0.12,
                color: 'transparent',
                selected: false,
                isCorrect: false,
            },
            {
                position: {
                    x: 0.765,
                    y: 0.255,
                },
                width: 0.18,
                height: 0.12,
                color: 'transparent',
                selected: false,
                isCorrect: false,
            },
        ],
    } as ClickMapQuestion,
    //5 true/false
    {
        type: QuestionType.MultipleChoice,
        image: require('../../assets/questionsAssets/images/move-out-of-blind-spot.jpg'),
        video: '',
        points: 1,
        text: "If you are in the truck's blind spot you should move to a position well clear of the blind spot, where the driver can see you.",
        questionAudio: '',
        descriptionAudio: '',
        descriptionConditions: 'imgRightLongAnswer',
        description:
            'REMEMBER: If you can’t see the truck driver in their side mirror, the driver can’t see you.',
        descriptionImage: require('../../assets/questionsAssets/images/move-out-of-blind-spot_answer.jpg'),
        answers: [
            { text: 'True', isCorrect: true, answer: false, background: '' },
            { text: 'False', isCorrect: false, answer: false, background: '' },
        ],
    } as MultipleChoiceQuestion,
    //6 true/false
    {
        type: QuestionType.MultipleChoice,
        image: require('../../assets/questionsAssets/images/trucks-leave-space.jpg'),
        video: '',
        points: 1,
        text: 'Trucks leave big spaces between them and the vehicles in front. This gap is needed to brake safely and is not an invitation for you to cut in front!',
        questionAudio: '',
        descriptionAudio: '',
        descriptionConditions: '',
        description:
            'It is dangerous to cut in front of a truck, they need twice as much room to brake as a car.',
        descriptionImage: '',
        answers: [
            { text: 'True', isCorrect: true, answer: false, background: '' },
            { text: 'False', isCorrect: false, answer: false, background: '' },
        ],
    } as MultipleChoiceQuestion,
    //7 true/false
    {
        type: QuestionType.MultipleChoice,
        image: require('../../assets/questionsAssets/images/trucks-merging_question.jpg'),
        video: '',
        points: 1,
        text: 'When merging into traffic on a freeway, it’s always safer to merge behind a truck rather than infront.',
        questionAudio: '',
        descriptionAudio: '',
        descriptionConditions: 'imgRightLongAnswer',
        description:
            'It is safer to merge after a truck has passed rather than in front.<br>Truck drivers will leave extra space in front of them, because they have a blind spot immediately in front of the truck and they need to maintain a safe stopping distance from other vehicles.<br> Leave space around trucks wherever possible. When merging with traffic, smoothly merge into the flow of traffic and match the speed of other vehicles on the freeway.',
        descriptionImage: require('../../assets/questionsAssets/images/trucks-merging_answer.jpg'),
        answers: [
            { text: 'True', isCorrect: true, answer: false, background: '' },
            { text: 'False', isCorrect: false, answer: false, background: '' },
        ],
    } as MultipleChoiceQuestion,
    //8 true/false
    {
        type: QuestionType.MultipleChoice,
        image: require('../../assets/questionsAssets/images/oversize-loads.jpg'),
        video: '',
        points: 1,
        text: 'A vehicle is classed as overwidth if that vehicle alone or together with any load exceeds 2.5 metres in width.',
        questionAudio: '',
        descriptionAudio: '',
        descriptionConditions: '',
        description:
            "When you're on the road, you may come across vehicles that are much bigger, wider and slower than you.<br>Please be patient!",
        descriptionImage: '',
        answers: [
            { text: 'True', isCorrect: true, answer: false, background: '' },
            { text: 'False', isCorrect: false, answer: false, background: '' },
        ],
    } as MultipleChoiceQuestion,
    //9 true/false
    {
        type: QuestionType.MultipleChoice,
        image: require('../../assets/questionsAssets/images/oversize-vehicles.jpg'),
        video: '',
        points: 1,
        text: 'If an oversize / overmass vehicle and pilot are approaching you, you should slow down, move to the left, prepare to stop and follow any directions given by the pilot vehicle.',
        questionAudio: '',
        descriptionAudio: '',
        descriptionConditions: '',
        description:
            "Many oversize vehicles are accompanied by a pilot vehicle, with rotating yellow lights and warning signs on it's roof.<br>Pilot vehicles warn approaching drivers to slow down until the oversize vehicle passes or stops if directed. Co-operate with the pilot vehicle driver when they signal you to move over as the oversize vehicle may need to be in the centre of the road.<br>If you move off the bitumen, slow down and watch for guideposts and any culverts. Use extra care if the road’s edge is wet.",
        descriptionImage: '',
        answers: [
            { text: 'True', isCorrect: true, answer: false, background: '' },
            { text: 'False', isCorrect: false, answer: false, background: '' },
        ],
    } as MultipleChoiceQuestion,
    // 10
    {
        type: QuestionType.ClickMap,
        image: require('../../assets/questionsAssets/images/5-7_14_who-can-be-drivers.jpg'),
        video: '',
        points: 1,
        text: 'Which of these people can be truck drivers?',
        questionAudio: '',
        descriptionAudio: '',
        descriptionConditions: '',
        description:
            'Anyone with the right license and training can become a truck driver!',
        descriptionImage: '',
        answers: [
            {
                position: {
                    x: 0.23,
                    y: 0.3,
                },
                width: 0.15,
                height: 0.65,
                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
            {
                position: {
                    x: 0.38,
                    y: 0.3,
                },
                width: 0.15,
                height: 0.65,
                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
            {
                position: {
                    x: 0.53,
                    y: 0.3,
                },
                width: 0.15,
                height: 0.65,
                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
            {
                position: {
                    x: 0.68,
                    y: 0.3,
                },
                width: 0.15,
                height: 0.65,
                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
        ],
    } as ClickMapQuestion,
    //11
    {
        type: QuestionType.LongMultipleChoice,
        image: require('../../assets/questionsAssets/images/12-15_15_What-Licence-C-class.png'),
        video: '',
        points: 1,
        text: 'What licence is needed to drive these vehicles?',
        questionAudio: '',
        descriptionAudio: '',
        descriptionConditions: '',
        description:
            'Car (C class) licences allow you to drive a motor vehicle with a gross vehicle mass (GVM) not greater than 4,500 kg and constructed or equipped to seat no more than 12 adults (including the driver).<br>There is no experience required to upgrade your licence from an R-E or C-A licence.<br>You can start learning to drive on attaining your restricted car licence (C-A class) automatic vehicles or your LAMS (R-E class) licence.',
        descriptionImage: '',
        answers: [
            {
                text: 'Car - C class licence',
                isCorrect: true,
                answer: false,
                background: '',
            },
            {
                text: 'Heavy Rigid - HR class heavy vehicle',
                isCorrect: false,
                answer: false,
                background: '',
            },
            {
                text: 'Light Rigid - LR class heavy vehicle',
                isCorrect: false,
                answer: false,
                background: '',
            },
        ],
    } as LongMultipleChoiceQuestion,
    //12
    {
        type: QuestionType.LongMultipleChoice,
        image: require('../../assets/questionsAssets/images/12-15_16_What-Licence-LR-class.png'),
        video: '',
        points: 1,
        text: 'What licence is needed to drive these vehicles?',
        questionAudio: '',
        descriptionAudio: '',
        descriptionConditions: '',
        descriptionImage: '',
        description:
            'Light Rigid (LR class) heavy vehicle heavy vehicle licences allow you to drive vehicles with either:<br>  •Gross vehicle mass (GVM) between 4,500 to 8,000 kg.<br>  •Capacity for more than 12 passengers (including the driver).<br>In order to gain an LR class licence, you must have held a Car (C class) licence for a minimum of 12 months.',
        answers: [
            {
                text: 'Car - C class licence',
                isCorrect: false,
                answer: false,
                background: '',
            },
            {
                text: 'Heavy Rigid - HR class heavy vehicle',
                isCorrect: false,
                answer: false,
                background: '',
            },
            {
                text: 'Light Rigid - LR class heavy vehicle',
                isCorrect: true,
                answer: false,
                background: '',
            },
        ],
    } as LongMultipleChoiceQuestion,
    //13
    {
        type: QuestionType.LongMultipleChoice,
        image: require('../../assets/questionsAssets/images/12-15_17_What-Licence-MR-class.png'),
        video: '',
        points: 1,
        text: 'What licence is needed to drive these vehicles?',
        questionAudio: '',
        descriptionAudio: '',
        descriptionConditions: '',
        descriptionImage: '',
        description:
            'MR (Medium Rigid class) heavy vehicle licences allow you to drive vehicles with 2 axles and a gross vehicle mass (GVM) greater than 8,000 kg. You will also be allowed to tow a trailer with a maximum GVM of 9,000 kg.<br>In order to gain an MR class licence, you must have held a C class car licence for a minimum of 12 months.',
        answers: [
            {
                text: 'Medium Rigid - MR class heavy vehicle',
                isCorrect: true,
                answer: false,
                background: '',
            },
            {
                text: 'Heavy Rigid - HR class heavy vehicle',
                isCorrect: false,
                answer: false,
                background: '',
            },
            {
                text: 'Light Rigid - LR class heavy vehicle',
                isCorrect: false,
                answer: false,
                background: '',
            },
        ],
    } as LongMultipleChoiceQuestion,
    //14
    {
        type: QuestionType.LongMultipleChoice,
        image: require('../../assets/questionsAssets/images/12-15_18_What-Licence-HR-class.png'),
        video: '',
        points: 1,
        text: 'What licence is needed to drive these vehicles?',
        questionAudio: '',
        descriptionAudio: '',
        descriptionConditions: '',
        description:
            'A Heavy Rigid (HR) vehicle licence allows you to drive heavy vehicles with three or more axles and a gross vehicle mass greater than 8,000 kg. You can also tow a trailer with a maximum GVM of 9,000 kg.<br>To gain an HR class licence, you must no longer be a provisional licence holder and have held:<br>  • A Car (C class) licence for at least 2 years, or<br>  • A Light Rigid (LR class) heavy vehicle licence for at least 1 year, or<br>  • A Medium Rigid (MR class) heavy vehicle licence for at least 1 year.',
        descriptionImage: '',
        answers: [
            {
                text: 'Medium Rigid - MR class heavy vehicle',
                isCorrect: false,
                answer: false,
                background: '',
            },
            {
                text: 'Heavy Rigid - HR class heavy vehicle',
                isCorrect: true,
                answer: false,
                background: '',
            },
            {
                text: 'Light Rigid - LR class heavy vehicle',
                isCorrect: false,
                answer: false,
                background: '',
            },
        ],
    } as LongMultipleChoiceQuestion,
    //15 need be shorter
    {
        type: QuestionType.LongMultipleChoice,
        image: require('../../assets/questionsAssets/images/HC-class.png'),
        video: '',
        points: 1,
        text: 'What licence is needed to drive these vehicles?',
        questionAudio: '',
        descriptionAudio: '',
        descriptionConditions: '',
        description:
            'Heavy Combination (HC class) heavy vehicle licences allow you to drive:<br>Prime movers with attached single semi-trailer.<br>  • Heavy Rigid (HR class) vehicles with attached trailer that has a Gross Vehicle Mass (GVM) greater than 9,000 kg.<br> To gain an HC class licence, you must no longer be a provisional licence holder and have held:<br>  • A Car (C class) licence for at least 3 years, and<br>  • A Medium Rigid (MR class) or HR class licence for at least 1 year.',
        descriptionImage: '',
        answers: [
            {
                text: 'Medium Rigid - MR class heavy vehicle',
                isCorrect: false,
                answer: false,
                background: '',
            },
            {
                text: 'Heavy Rigid - HR class heavy vehicle',
                isCorrect: false,
                answer: false,
                background: '',
            },
            {
                text: 'Heavy Combination - HC class heavy vehicle',
                isCorrect: true,
                answer: false,
                background: '',
            },
        ],
    } as LongMultipleChoiceQuestion,
    //16
    {
        type: QuestionType.LongMultipleChoice,
        image: require('../../assets/questionsAssets/images/12-15_20_What-Licence-MC-class.png'),
        video: '',
        points: 1,
        text: 'What licence is needed to drive these vehicles?',
        questionAudio: '',
        descriptionAudio: '',
        descriptionConditions: '',
        description:
            'Multi Combination (MC class) heavy vehicle licence allows you to drive any heavy combination unit towing two or more trailers, each having a gross vehicle mass greater than 9,000 kg.<br>To gain an MC class licence, you must no longer be a provisional licence holder and have held:<br>  • A Car (C class) licence for at least 3 years, and<br>  • A Heavy Rigid (HR class) or Heavy Combination (HC class) licence for at least 1 year.',
        descriptionImage: '',
        answers: [
            {
                text: 'Multi Combination - MC class heavy vehicle',
                isCorrect: true,
                answer: false,
                background: '',
            },
            {
                text: 'Heavy Rigid - HR class heavy vehicle',
                isCorrect: false,
                answer: false,
                background: '',
            },
            {
                text: 'Light Rigid - LR class heavy vehicle',
                isCorrect: false,
                answer: false,
                background: '',
            },
        ],
    } as LongMultipleChoiceQuestion,
    // 17
    {
        type: QuestionType.LongMultipleChoice,
        image: require('../../assets/questionsAssets/images/factors-effecting-stopping.jpg'),
        video: '',
        points: 1,
        text: 'What are some of the factors that can affect a trucks stopping distance?',
        questionAudio: '',
        descriptionAudio: '',
        descriptionConditions: '',
        description:
            'There are lots of factors that can affect a trucks ability to stop. Never cut in front of a truck!',
        descriptionImage: '',
        answers: [
            {
                text: 'Vehicle speed',
                isCorrect: true,
                answer: false,
                background: '',
            },
            {
                text: 'Vehicle weight',
                isCorrect: true,
                answer: false,
                background: '',
            },
            {
                text: 'Tyre condition',
                isCorrect: true,
                answer: false,
                background: '',
            },
            {
                text: 'Road surface',
                isCorrect: true,
                answer: false,
                background: '',
            },
            {
                text: 'Braking efficiency',
                isCorrect: true,
                answer: false,
                background: '',
            },
        ],
    } as LongMultipleChoiceQuestion,
    //18
    {
        type: QuestionType.MultipleChoice,
        image: require('../../assets/questionsAssets/images/how-long-to-stop.jpg'),
        video: '',
        points: 1,
        text: 'How long does it take to stop an average heavy vehicle semi-trailer truck travelling at 80km/h?',
        questionAudio: '',
        descriptionAudio: '',
        descriptionConditions: '',
        description:
            ' Trucks require more stopping distance. If you cut in front of a truck and then brake suddenly, you could cause a crash.',
        descriptionImage: '',
        answers: [
            { text: '55m', isCorrect: false, answer: false, background: '' },
            { text: '90m', isCorrect: false, answer: false, background: '' },
            { text: '116m', isCorrect: true, answer: false, background: '' },
            { text: '150m', isCorrect: false, answer: false, background: '' },
        ],
    } as MultipleChoiceQuestion,
    //19
    {
        type: QuestionType.MultipleChoice,
        image: require('../../assets/questionsAssets/images/maximum-speed.jpg'),
        video: '',
        points: 1,
        text: 'What is the maximum speed limit for vehicles with a gross combined mass (GCM) over 12 tonnes?',
        questionAudio: '',
        descriptionAudio: '',
        description:
            'Buses and coaches over 5 tonnes gross vehicle mass and vehicles towing caravans, recreational vehicles or trailers are also limited to 100km/h.<br>Speed limits are the maximum allowed under the best conditions.',
        descriptionConditions: '',
        descriptionImage: '',
        answers: [
            { text: '80km/h', isCorrect: false, answer: false, background: '' },
            { text: '90km/h', isCorrect: false, answer: false, background: '' },
            { text: '100km/h', isCorrect: true, answer: false, background: '' },
            {
                text: '110km/h',
                isCorrect: false,
                answer: false,
                background: '',
            },
        ],
    } as MultipleChoiceQuestion,
    //20 true/false
    {
        type: QuestionType.MultipleChoice,
        image: require('../../assets/questionsAssets/images/slomo-law.jpg'),
        video: '',
        points: 1,
        text: 'The Slow Down, Move Over or SLOMO law requires drivers to slow down to 40 km/h when approaching stationary emergency vehicles displaying flashing lights while attending an incident.',
        questionAudio: '',
        descriptionAudio: '',
        descriptionConditions: '',
        description:
            'Drivers in ALL lanes travelling in the same direction as the lane where the emergency or incident response vehicles with flashing lights are stopped are required to safely slow down and travel at no more than 40km/h when passing.<br>(Vehicles travelling in oncoming traffic from the other direction are not required to slow down, unless the incident has occurred in the middle of the road or on a median strip.)',
        descriptionImage: '',
        answers: [
            { text: 'True', isCorrect: true, answer: false, background: '' },
            {
                text: 'False',
                isCorrect: false,
                answer: false,
                background: '',
            },
        ],
    } as MultipleChoiceQuestion,
    //21
    {
        type: QuestionType.MultipleChoice,
        image: require('../../assets/questionsAssets/images/common-freights.png'),
        video: '',
        points: 1,
        text: 'In Australia, which mode of transport is most commonly used to move freight around?',
        questionAudio: '',
        descriptionAudio: '',
        descriptionConditions: '',
        description: '70% of Australian freight is transported by trucks!',
        descriptionImage: '',
        answers: [
            {
                text: 'Ships',
                isCorrect: false,
                answer: false,
                background: '',
            },
            {
                text: 'Trains',
                isCorrect: false,
                answer: false,
                background: '',
            },
            {
                text: 'Trucks',
                isCorrect: true,
                answer: false,
                background: '',
            },
        ],
    } as MultipleChoiceQuestion,

    //23 true/false
    {
        type: QuestionType.MultipleChoice,
        image: require('../../assets/questionsAssets/images/animal-crash.jpg'),
        video: '',
        points: 1,
        text: '1 in 7 crashes on country roads involve an animal.',
        questionAudio: '',
        descriptionAudio: '',
        descriptionConditions: '',
        description:
            'When driving always remember to be alert and keep an eye out for animals, stay within speed limits; drive to conditions, be cautious around water points like dams and creeks and avoid driving at dawn and dusk.',
        descriptionImage: '',
        answers: [
            { text: 'True', isCorrect: true, answer: false, background: '' },
            { text: 'False', isCorrect: false, answer: false, background: '' },
        ],
    } as MultipleChoiceQuestion,
    //24 true/false
    {
        type: QuestionType.MultipleChoice,
        image: '',
        video: require('../../assets/questionsAssets/videos/8-11_7_truck-turbulence.mp4'),
        points: 1,
        text: 'Can driving in different environments affect your visibility?',
        questionAudio: '',
        descriptionAudio: '',
        descriptionConditions: '',
        description:
            'Environmental conditions like fog, rain and dust storms as well as the time of day, can reduce your visibility, especially if you are behind a truck. Turn your headlights on, stay alert and drive to conditions.',
        descriptionImage: '',
        answers: [
            { text: 'Yes', isCorrect: true, answer: false, background: '' },
            { text: 'No', isCorrect: false, answer: false, background: '' },
        ],
    } as MultipleChoiceQuestion,
    // 25
    {
        type: QuestionType.ClickMap,
        image: require('../../assets/questionsAssets/images/trucks-can-carry.jpg'),
        video: '',
        points: 1,
        text: 'Trucks can carry all sorts of everyday items, touch or click on the items that you think have been carried by a truck.',
        questionAudio: '',
        descriptionAudio: '',
        descriptionConditions: '',
        description: 'Trucks deliver almost everything we use and eat.',
        descriptionImage: '',
        answers: [
            {
                position: {
                    x: 0.7,
                    y: 0.22,
                },
                width: 0.25,
                height: 0.25,
                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
            {
                position: {
                    x: 0.228,
                    y: 0.42,
                },
                width: 0.18,
                height: 0.15,
                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
            {
                position: {
                    x: 0.505,
                    y: 0.4,
                },
                width: 0.2,
                height: 0.17,
                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
            {
                position: {
                    x: 0.405,
                    y: 0.31,
                },
                width: 0.1,
                height: 0.32,
                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
            {
                position: {
                    x: 0.505,
                    y: 0.57,
                },
                width: 0.2,
                height: 0.25,
                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
            {
                position: {
                    x: 0.8,
                    y: 0.47,
                },
                width: 0.18,
                height: 0.3,
                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
            {
                position: {
                    x: 0.02,
                    y: 0.32,
                },
                width: 0.21,
                height: 0.25,
                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
            {
                position: {
                    x: 0.015,
                    y: 0.57,
                },
                width: 0.39,
                height: 0.18,
                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
            {
                position: {
                    x: 0.06,
                    y: 0.75,
                },
                width: 0.31,
                height: 0.21,
                color: 'transparent',
                selected: false,
                isCorrect: true,
            },
        ],
    } as ClickMapQuestion,
];
